<div class="contentContainer">

  <!------------------------------------------------------------------------------ header -->

  <div fxLayout="row" fxLayoutAlign="space-between center" class="headerContentContainer">
    <div fxLayout="row">
    <div fxLayoutAlign="center center" class="grayLink" (click)="routeService.goBack()">
        <mat-icon class="linkIcon ft22">arrow_back</mat-icon>
      </div>
      <div>
        <h6 *ngIf="id==null" class="mgl10 ft500 ft16 mgb0 gray-9"> Historial de pagos</h6>
        <h6 *ngIf="id" class="mgl10 ft500 ft16 mgb0 gray-9"> Historial de pagos {{instructorNombre}}</h6>

      </div>
    </div>
  </div>

    <!------------------------------------------------------------------------------ Table -->

  <div class="tableContainer">

    <!-- Table Header -->
    <table class="w-100">
      <tr class="tableHeaderContainer">
        <th>Fecha de pago</th>
        <th>Nombre Instructor</th>
        <th>Instructor Id</th>
        <th>Identificador de Pago</th>
        <th>Via de pago</th>
        <th>Total</th>
        <th>Estatus</th>
      </tr>

      <!-- Table Data -->
      <tr *ngFor="let item of pagos;  let i=index">
        <td class="centertext w-10"> {{item.instructorFechaPago.toDate() | date}}</td>
        <td class="w-20 centertext">
          <a routerLink="/admin/pagos/{{item.instructorId}}" class="blueLink ft500 ft12">{{item.instructorNombre}}</a>
        </td>
        <td class="centertext w-10"> {{item.instructorId}}</td>
        <td class="centertext w-10">
          <a routerLink="/admin/detalle-pago/{{item.pagoId}}" class="blueLink ft500 ft12">{{item.pagoId}}</a>
        </td>
        <td class="centertext w-10"> {{item.instructorViaPago}}</td>
        <td class="centertext w-10"> {{item.pagoTotal}}</td>
        <td class="centertext w-10"> 
          <div *ngIf="item.instructorEstatusPago==='pagado'" class="sqChip backGreen5 ft11">
            {{item.instructorEstatusPago}}
        </div>
        <div *ngIf="item.instructorEstatusPago==='pendiente'" class="sqChip backRed5 ft11">
            {{item.instructorEstatusPago}}
        </div>
        <div *ngIf="item.instructorEstatusPago==='en proceso'" class="sqChip backOrange3 ft11">
            {{item.instructorEstatusPago}}
        </div>
          
        </td>
      </tr>
    </table>
  </div>

</div>